/**
 * #809: dispatched on `window` when the server closes a live collab socket because its session
 * was REVOKED (a share-view "Log out", an account's sign-out-everywhere) — so the surface that
 * owns the session (the share view) can tell "logged out" from a network blip. Dependency-free
 * here so the dispatcher (`useYjs`) and the listener share one name.
 */
export const COLLAB_SESSION_REVOKED_EVENT = 'papan:collab-session-revoked'
